<template>
    <v-container grid-list-md text-xs-center class="fluid pb-5 mb-5 mt-4">
        <v-container class="fluid mt-4 pb-2 mb-2">
            <div class="row block-content elevation-0 p-2 row-container mt-4 pb-5 mb-5">
                <v-flex xs10 class="border offset-1 pb-2">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="font-weight-black headline" style="color:#ffa409">
                                <v-icon color="#ffa409">&#xe15e;</v-icon>  
                                Ho il y a eu un problème lors de la création du contrat
                            </span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false" class="float-lg-right">
                            <v-icon color="red">&#xe5cd;</v-icon>
                        </v-btn>
                    </v-toolbar>           
                    <div class="row mt-5 p-3 justify-content-center">
                        <span class="h4 font-weight-bold alert-text  border p-2 rounded"> 
                           Notre système a détecté un contrat encours pour l’un de vos véhicules
                           concernant la période souhaitée
                        </span>
                    </div>
                    <div class="row mt-5 p-3 justify-center">
                        <v-btn to="/" round color="#ffa409" class="got text-white">
                            Retour à l'accueil
                        </v-btn>
                    </div>
                </v-flex>
            </div>
        </v-container>    
    </v-container>
</template>

<script>
export default {
    data(){
        return{
            yourValue:null,
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        if (!this.$store.state.user || this.$store.state.user===null) {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped>
    .row-container{
        background: white;
    }
    .alert-text{
        color:red;
        text-align: center;
    }
    .got:hover{
        text-decoration: none;
    }
    .rounded{
        border-radius: 10px!important;
    }
</style>

 